import React from 'react'
import Highcharts from 'highcharts'
import HighchartsMore from 'highcharts/highcharts-more'
import Exporting from 'highcharts/modules/exporting'
import ExportData from 'highcharts/modules/export-data'
import HighchartsReact from 'highcharts-react-official'

HighchartsMore(Highcharts)
Exporting(Highcharts)
ExportData(Highcharts)

export default function WindroseGraph(props) { 
  const { userParams, options } = props;
  // Any of these options can be overridden via this.props.options
  const localOptions = {
    accessibility: {
      enabled:false,
    },
    chart: {
      polar:true,
      type:"column",
      height: "80%",
    },
    plotOptions: {
      series: {
        stacking:"normal",
        shadow:false,
        groupPadding:0,
        pointPlacement:"on"
      }
    },
    xAxis: { 
      type:"category",
      tickmarkPlacement:"on"
    },
    yAxis: { 
      min:0,
      endOnTick:false,
      showFirstLabel: false,
      showLastLabel:true,
      reversedStacks:false,
      labels: {
        format: userParams.pctcnt === "percent" ? "{value}%" : "{value}"
      },
    },
    legend: {
      align:"right",
      verticalAlign:"middle",
      layout:"vertical",
      title: {
        text: "Wind speed" + (userParams.wsunits ? (" (" + userParams.wsunits + ")") : "")
      }
    },
    exporting: {
      menuItemDefinitions: {
        // Custom definition
        downloadCSV: {
          text: 'Download as CSV table'
        },
        downloadXLS: {
          text: 'Download as XLS table'
        }
      },
      buttons: {
        contextButton: {
          menuItems: [
            "printChart",
            "separator",
            "downloadPNG",
            "downloadJPEG",
            "downloadPDF",
            "downloadSVG",
            "separator",
            "downloadCSV",
            "downloadXLS",
  //              "viewData",
  //          "openInCloud"
          ]
        }
      }
    },
    credits: {
      href: "https://www.rcc-acis.org",
      text: "Powered by ACIS"
    },
    // Following are expected, but not required, to be provided via props options
    title: {
      text:"",
    },
    subtitle: {
      text:""
    },
    // This must be provided via options.series in props
    series: null
  };

  const fc = userParams.pctcnt.charAt(0).toUpperCase() + userParams.pctcnt.slice(1)
  const wsunits = userParams.wsunits
  const dirunits = userParams.directbincnt === 36 ? " degrees" : ""
  const res = userParams.pctcnt === "percent" ? 1 : 0
  const suffix = userParams.pctcnt === "percent" ? "%" : ""
  localOptions.tooltip = {
    formatter: function() {
      return fc + " of hours with wind speed " + this.series.name + " " + wsunits + 
        " and wind direction is from " + this.point.name + dirunits + ": " + this.y.toFixed(res) + suffix
    }
  }
  const allOptions = {...localOptions, ...options}

  return (
    <>
      {options.series &&
        <HighchartsReact
          highcharts={Highcharts}
          options={allOptions}
        />
      }
    </>
  )
} 